import React from 'react';
import cs from 'classnames';
import Card from '@starbucks-web/pattern-library/lib/components/card/';
import { STATUS_LEVELS } from './constants';

const rewardsLevelColorMap = {
  [STATUS_LEVELS.GREEN.toLowerCase()]:
    'color-greenOnPrimary bg-greenLoyaltySurfaceGreen',
  [STATUS_LEVELS.GOLD.toLowerCase()]:
    'color-greenOnPrimary bg-goldLoyaltySurfaceGold',
  [STATUS_LEVELS.RESERVE.toLowerCase()]:
    'color-whiteOnAccent2 bg-blackLoyaltySurfaceReserve',
};

const LoyaltyCard = ({
  rewardsLevel,
  children,
  contentClasses,
  containerClasses,
  ...otherProps
}) => {
  const cardClasses = cs(
    'width-100 borderRadius-lgBang',
    rewardsLevelColorMap[rewardsLevel],
    containerClasses
  );

  return (
    <Card
      containerClasses={cardClasses}
      contentClasses={contentClasses}
      {...otherProps}
    >
      {children}
    </Card>
  );
};

export default LoyaltyCard;
